import angular from 'angular';

TareaActionsService.$inject = ['$log', 'dialogService', '$http', '$q', 'DialogsService', 'Tarea'];
export default function TareaActionsService($log, dialogService, $http, $q, DialogsService, Tarea) {

    var TAG = 'TareaActionsService: ';
    var DIALOG_EDIT_ESTADO_TAREA_TEMPLATE = require('./edit-estado/dialog-edit-estado-tarea.html');
    var DIALOG_EDIT_ESTADO_TAREA_ID = 'dialog-edit-estado-tarea';
    var DIALOG_FINALIZAR_TEMPLATE = require('./finalizar/tareasFinalizarDialog.html');
    var DIALOG_NO_HAY_NADA_TEMPLATE = require('./finalizar/tareasNoHayNadaDialog.html');
    var DIALOG_FINALIZAR_ID = 'dialog-finalizar-tarea';
    var DIALOG_RECHAZAR_TEMPLATE = require('./dialog-rechazar-tarea.html');
    var DIALOG_RECHAZAR_ID = 'dialogRechazarTarea';
    var DIALOG_DUPLICADA_TEMPLATE = require('./dialog-duplicada-tarea.html');
    var DIALOG_DUPLICADA_ID = 'dialogDuplicadaTarea';
    var DIALOG_REDIRIGIDA_TEMPLATE = require('./dialgo-redirigida-tarea.html');
    var DIALOG_REDIRIGIDA_ID = 'dialogRedirigidaTarea';
    var DIALOG_APERTURA_EXP_TEMPLATE = require('./dialog-apertura-exp-tarea.html');
    var DIALOG_APERTURA_EXP_ID = 'dialogApertExpTarea';
    var DATEFROMAT_SERVIDOR = "YYYY-MM-DD HH:mm:ss";
    var DATEFROMAT_WEB = "DD/MM/YYYY HH:mm";

    var DIALOG_ANYADIR_A_LISTA_TEMPLATE = require('./listas/select-lista-dialog.html');
    var DIALOG_ANYADIR_A_LISTA_ID = 'dialogSelectListaDialog';

    const DIALOG_FECHA_INI_PREVISTA_DIALOG_TEMPLATE = require('./fecha-ini-prevista/fecha-ini-prevista-dialog.html');
    const DIALOG_FECHA_INI_PREVISTA_ID = 'fechaIniPrevistaDialog';

    var URL_TAREAS_BASE = Sigo.var.path + '/obras';

    return {
        cambiarEstadoTareas: cambiarEstadoTareas,
        cambiarEstadoEstudioTareas: cambiarEstadoEstudioTareas,
        finalizarTarea: _finalizarTarea,
        finalizarTareas: _finalizarTareas,
        rechazarTarea: rechazarTarea,
        pausarTarea: _pausarTarea,
        marcarComoDuplicada: marcarComoDuplicada,
        marcarComoRedigida: marcarComoRedirigida,
        marcarComoAperturaExpediente: marcarComoAperturaExp,
        editarFechaPrevista: _editarFechaPrevista,
        editarFechaIniPrevista: _editarFechaIniPrevista,
        editarFechaFinalizacion: _editarFechaFinalizacion,
        noHayNadaTarea: _noHayNadaTarea,
        noHayNadaTareas: _noHayNadaTareas,
        anyadirAListaTareas: _anyadirAListaTareas,
        cambioEstadoConComentario: _cambioEstadoConComentario
    };

    function __cambiarEstadoBase(codigosTareas, tipo, titulo) {
        var datos = {
            codigos: codigosTareas,
            tipo: tipo
        };

        var opcionesExtra = {deshabilitarBotones: true};

        return __abrirDialogo(titulo, datos, opcionesExtra, DIALOG_EDIT_ESTADO_TAREA_ID, DIALOG_EDIT_ESTADO_TAREA_TEMPLATE);
    }

    function cambiarEstadoTareas(codigosTareas) {
        $log.debug(TAG + 'Editando el estado de reparación de algunas tareas...');

        var titulo = StringUtils.ucfirst(Lang.get('nombres.editar') + ' ' + Lang.get('nombres.estado_reparacion'));
        return __cambiarEstadoBase(codigosTareas, 'reparacion', titulo);
    }

    function cambiarEstadoEstudioTareas(codigosTareas) {
        $log.debug(TAG + 'Editando el estado de estduio de algunas tareas...');

        var titulo = StringUtils.ucfirst(Lang.get('nombres.editar')) + ' ' + Lang.get('nombres.estado_tecnico');
        return __cambiarEstadoBase(codigosTareas, 'estudio', titulo);
    }

    function _finalizarTareas(codigos) {
        return __solicitarFechaFinalizacion(null, undefined, codigos).then(__respuestaPromesaCorrecta('grid'));
    }

    function _noHayNadaTareas(codigos) {
        return __solicitarFechaFinalizacion(null, 'noHayNada', codigos).then(__respuestaPromesaCorrecta('grid'));
    }

    function _anyadirAListaTareas(codigos) {
        var titulo = Lang.get('seccion_tareas.accion_anyadir_a_lista_des');
        var botones = {
            botonOk: ucfirst(Lang.choice('nombres.anyadir', 1))
        };

        return __abrirDialogo(titulo, {}, botones, DIALOG_ANYADIR_A_LISTA_ID, DIALOG_ANYADIR_A_LISTA_TEMPLATE).then(
            function (result) {
                if (issetAndNotEmpty(result) && isNumeric(result.lista_id)) {
                    var lista_id = result.lista_id;
                    return __anyadirAListaTareasServer(codigos, lista_id);
                }

            }
        );
    }

    function _noHayNadaTarea(tareaId, origin) {
        __solicitarFechaFinalizacion(tareaId, 'noHayNada').then(__respuestaPromesaCorrecta(origin));
    }

    function _finalizarTarea(tareaId, origin) {
        __solicitarFechaFinalizacion(tareaId).then(__respuestaPromesaCorrecta(origin));
    }

    function __solicitarFechaFinalizacion(tareaId, tipo, codigos) {
        var dataToDialog = {};

        if (isSet(codigos)) {
            dataToDialog.codigos = codigos;
        } else {
            dataToDialog.id = tareaId;
        }

        tipo = !isSet(tipo) ? 'fin' : tipo;
        var titulo = Lang.get('mensajes.confirmacion_finalizar');
        var dialogTemplate = DIALOG_FINALIZAR_TEMPLATE;

        if (tipo == 'noHayNada') {
            titulo = Lang.get('mensajes.confirmacion_no_hay_nada');
            dialogTemplate = DIALOG_NO_HAY_NADA_TEMPLATE;
            dataToDialog.noHayNada = true;
        }

        return __abrirDialogo(titulo, dataToDialog, {deshabilitarBotones: true, devolverDatos: true},
            DIALOG_FINALIZAR_ID, dialogTemplate);
    }

    function rechazarTarea(tareaId, rol, origin) {
        var tecOAdm = Sigo.user.esTecnico || Sigo.user.esAdmin;
        var tipoRechazar = typeof rol !== 'undefined' && tecOAdm && Sigo.config['permitir_estado_obra_rechazada'] ? rol :
            tecOAdm || !Sigo.config['permitir_estado_obra_rechazada'] ? 'tecnico' : 'reparador';

        var titulo = Lang.get('estados.rechazar') + ' ' + Lang.choice('nombres.tarea', 1);

        var extraOptions = {
            botonOk: Lang.get('estados.rechazar')
        };

        var dialogo = __abrirDialogo(titulo, {id: tareaId}, extraOptions, DIALOG_RECHAZAR_ID, DIALOG_RECHAZAR_TEMPLATE);

        dialogo.then(function (result) {
            var msg = result.mensaje;
            if (!Sigo.config['comentarios']['estado_modulo'] || (msg != undefined && msg.length > 0)) {
                rechazarTareaServer(tareaId, msg, tipoRechazar, origin);
            } else {
                Sigo.UI.Messages.open([Lang.get('mensajes.escribir_comentario')], 0);
            }
        });
    }

    function _pausarTarea(tareaId, rol, origen) {
        var tecOAdm = Sigo.user.esTecnico || Sigo.user.esAdmin;
        var tipoPausar = typeof rol !== 'undefined' && tecOAdm ? rol : tecOAdm ? 'tecnico' : 'reparador';

        var titulo = ucfirst(Lang.get('estados.pausar')) + ' ' + Lang.choice('nombres.tarea', 1);

        var extraOptions = {
            botonOk: ucfirst(Lang.get('estados.pausar'))
        };

        var dialogo = __abrirDialogo(titulo, {
            id: tareaId,
            tipo: 'pausar'
        }, extraOptions, DIALOG_RECHAZAR_ID, DIALOG_RECHAZAR_TEMPLATE);

        dialogo.then(function (result) {
            var msg = result.mensaje;
            if (!Sigo.config['comentarios']['estado_modulo'] || (msg != undefined && msg.length > 0)) {
                pausarTareaServer(result, tipoPausar, origen);

            } else {
                Sigo.UI.Messages.open([Lang.get('mensajes.escribir_comentario')], 0);
            }
        });
    }

    function _cambioEstadoConComentario(tareaId, estadoId, origen) {
        const titulo = ucfirst(Lang.get('nombres.cambiar')) + ' ' + Lang.choice('nombres.estado', 1);

        const extraOptions = {botonOk: ucfirst(Lang.get('nombres.cambiar'))};

        const dialogo = __abrirDialogo(titulo, {id: tareaId}, extraOptions, DIALOG_RECHAZAR_ID, DIALOG_RECHAZAR_TEMPLATE);

        dialogo.then(function (result) {
            const msg = result.mensaje;
            if (!Sigo.config['comentarios']['estado_modulo'] || (msg !== undefined && msg.length > 0))
                _cambiarTareaServer(tareaId, estadoId, msg, origen);
            else
                Sigo.UI.Messages.open([Lang.get('mensajes.escribir_comentario')], 0);
        });
    }

    function marcarComoDuplicada(tareaId, origin) {
        var titulo = ucfirst(Lang.get('mensajes.confirmacion_duplicada')) + ' ' + Lang.choice('nombres.tarea', 1);

        var opcionesExtra = {
            botonOk: Lang.choice('nombres.duplicada', 1),
            validate: function (model) {
                var mensajeIsset = issetAndNotEmpty(model) && angular.isDefined(model.mensaje);
                var mensajeConTarea = mensajeIsset && model.mensaje.indexOf("#") != -1;
                var esCodigoDesconocido = angular.isDefined(model.codigoDesconocido) && model.codigoDesconocido;

                var valida = mensajeIsset && (esCodigoDesconocido || mensajeConTarea);
                if (!valida) {
                    var msgError = esCodigoDesconocido ? 'comentario_motivo' : 'error_duplicar_tarea';
                    Sigo.UI.Messages.open([Lang.get('mensajes.' + msgError)], false);
                }

                return valida;
            },
            beforeClose: function (model) {
                var esCodigoDesconocido = angular.isDefined(model.codigoDesconocido) && model.codigoDesconocido;
                if (angular.isDefined(model.mensaje) && esCodigoDesconocido)
                    model.mensaje += ' ' + Lang.get('mensajes.se_desconece_codigo_tarea');
            }
        };

        var dialogo = __abrirDialogo(titulo, {id: tareaId}, opcionesExtra, DIALOG_DUPLICADA_ID, DIALOG_DUPLICADA_TEMPLATE);

        dialogo.then(function (result) {
            var msg = result.mensaje;
            if (!Sigo.config['comentarios']['estado_modulo'] || (msg != undefined && msg.length > 0)) {
                marcarComoDuplicadaServer(tareaId, result.mensaje, origin);
            } else {
                Sigo.UI.Messages.open([Lang.get('mensajes.escribir_comentario')], 0);
            }
        });
    }

    function marcarComoRedirigida(tareaId, origin) {
        var titulo = Lang.get('mensajes.confirmacion_redirigida') + ' ' + Lang.choice('nombres.tarea', 1);
        var botones = {
            botonOk: Lang.choice('nombres.redirigida', 1)
        };

        var dialogo = __abrirDialogo(titulo, {id: tareaId}, botones, DIALOG_REDIRIGIDA_ID, DIALOG_REDIRIGIDA_TEMPLATE);

        dialogo.then(function (result) {
            var msg = result.mensaje;
            if (!Sigo.config['comentarios']['estado_modulo'] || (msg != undefined && msg.length > 0)) {
                marcarComoRedirigidaServer(result, origin);
            } else {
                Sigo.UI.Messages.open([Lang.get('mensajes.escribir_comentario')], 0);
            }
        });
    }

    function marcarComoAperturaExp(tareaId, origin) {
        var titulo = Lang.get('mensajes.confirmacion_apert_exp') + ' ' + Lang.choice('nombres.tarea', 1);
        var botones = {
            botonOk: Lang.choice('estados.apertura_expediente', 1),
        };

        var dialogo = __abrirDialogo(titulo, {id: tareaId}, botones, DIALOG_APERTURA_EXP_ID, DIALOG_APERTURA_EXP_TEMPLATE);

        dialogo.then(function (result) {
            var msg = result.mensaje;
            if (!Sigo.config['comentarios']['estado_modulo'] || (msg != undefined && msg.length > 0)) {
                marcarComoAperturaExpServer(tareaId, result.mensaje, origin);
            } else {
                Sigo.UI.Messages.open([Lang.get('mensajes.escribir_comentario')], 0);
            }
        });
    }

    /** -------------------------------------------------------------------------------------------------------------------------------- **/

    /** --------------------------------- PETICIONES AL SERVIDOR ----------------------------------------------------------------------- **/
    /** -------------------------------------------------------------------------------------------------------------------------------- **/

    function __anyadirAListaTareasServer(codigos, listaId) {
        var data = {
            codigos: codigos,
            lista_id: listaId
        };

        var respuestaCorrecta = function (data) {
            Sigo.UI.Messages.procesarRespuestaMultiplesAcciones(data.data);
            GridUtils.setVisibilityProcessing('grid', 'hidden');
        };

        return __peticionServer('/anyadir-lista', data, 'grid', respuestaCorrecta);
    }

    function pausarTareaServer(model, tipoPausar, origen) {
        $http.post(URL_TAREAS_BASE + '/pausar-tarea/' + model.id + '/' + tipoPausar, model)
            .success(function (data) {
                if (isArrayAndNotEmpty(data.messages)) Sigo.UI.Toast.success('', data.messages[0]);
                if (issetAndNotEmpty(origen)) __actualizarFila(data, origen);
            })
            .error(function (data) {
                Sigo.UI.Toast.success('', data.error.message);
            });
    }

    function _cambiarTareaServer(tareaId, estadoId, mensaje, origen) {
        const params = {
            id: tareaId,
            estado: estadoId
        };

        if (typeof mensaje !== "undefined" && mensaje != null) params.mensaje = mensaje;

        $http.post(URL_TAREAS_BASE + '/estadoobra', params)
            .success(function (data) {
                if (isArrayAndNotEmpty(data.messages)) Sigo.UI.Toast.success('', data.messages[0]);
                if (issetAndNotEmpty(origen)) __actualizarFila(data, origen);
            })
            .error(function (data) {
                Sigo.UI.Toast.success('', data.error.message);
            });
    }

    function marcarComoDuplicadaServer(tareaId, mensaje, origin) {
        var datos = {
            mensaje: mensaje
        };

        return __peticionServer('/marcar-duplicada/' + tareaId, datos, origin, __respuestaPromesaCorrecta(origin));
    }

    function marcarComoAperturaExpServer(tareaId, mensaje, origin) {
        var data = {
            mensaje: mensaje
        };

        return __peticionServer('/marcar-apertura-expediente/' + tareaId, data, origin, __respuestaPromesaCorrecta(origin));
    }

    function marcarComoRedirigidaServer(model, origin) {
        return __peticionServer('/marcar-como-redirigida/' + model.id, model, origin, __respuestaPromesaCorrecta(origin));
    }

    function rechazarTareaServer(tareaId, mensaje, tipoRechazar, origin) {
        var datos = {
            mensaje: mensaje
        };

        return __peticionServer('/rechazar-tarea/' + tareaId + '/' + tipoRechazar, datos, origin, __respuestaPromesaCorrecta(origin));
    }

    /** -------------------------------------------------------------------------------------------------------------------------------- **/

    /** --------------------------------- FUNCIONES PRIVADAS --------------------------------------------------------------------------- **/
    /** -------------------------------------------------------------------------------------------------------------------------------- **/

    function __abrirDialogo(titulo, params, optExtr, dialogId, dialogTemplate) {

        if (issetAndNotEmpty(optExtr.botonOk)) optExtr.botonOk = ucfirst(optExtr.botonOk);
        optExtr.botonCancell = issetAndNotEmpty(optExtr.botonCancell)
            ? ucfirst(optExtr.botonCancell) : ucfirst(Lang.get('nombres.cancelar'));
        titulo = ucfirst(titulo);

        var options = {
            autoOpen: false,
            modal: true,
            title: titulo,
            minWidth: 600
        };

        return dialogService.open(dialogId, dialogTemplate, params, options, optExtr);
    }

    function __peticionServer(url, datos, origin, respuestaPromesaCorrecta) {
        GridUtils.setVisibilityProcessing(origin, 'visible');

        var promesa = $http.post(URL_TAREAS_BASE + url, datos);
        promesa.then(respuestaPromesaCorrecta, __respuestaPromesaErronea(origin));

        return promesa;
    }

    function __respuestaPromesaCorrecta(origin) {
        return function (data) {
            var respuesta = data.data;
            if (issetAndNotEmpty(respuesta.messages)) Sigo.UI.Messages.open(respuesta.messages, 0);
            if (angular.isDefined(respuesta.tareas_actualizadas)) {
                for (var i = 0; i < respuesta.tareas_actualizadas.length; i++)
                    actualizaFilaVTarea(respuesta.tareas_actualizadas[i]);
            } else {
                __actualizarFila(respuesta, origin);
            }

            GridUtils.setVisibilityProcessing(origin, 'hidden');
        };
    }

    function __respuestaPromesaErronea(origin) {
        return function () {
            GridUtils.setVisibilityProcessing(origin, 'hidden');
        }
    }

    function __actualizarFila(respuesta, origen) {
        if (origen == 'tipos-tareas')
            actualizaFilaVIncidencia(respuesta.vincidencia, true);
        else if (origen == 'map') {
            var tarea = respuesta.tarea;
            var popUpData = $("#popupData");

            popUpData.attr('data-obra_cod', tarea.estadoobra_id);
            popUpData.attr('data-estadotecnico-id', tarea.estadotecnico_id);
            popUpData.attr('data-estadoobra_id', tarea.estadotecnico_id);

            $("#popupDesEstadoTecnico").html(linkEstadoTecnico(tarea.DesEstadoTecnico, tarea.ColorEstadoTecnico, 'map'));
            $("#popupDesEstadoObra").html(linkEstadoObra(tarea.estadotecnico_id, tarea.DesEstadoObra, tarea.estadoobra_id, tarea.ColorEstadoObra, 'map'));

        } else
            actualizaFilaVTarea(respuesta.tarea, true);
    }

    function editarFechaFinalizacionPrevista(tareaId, fechaFinalizacionPrevista) {
        $log.debug(TAG + 'Editando fecha prevista de la tarea ' + tareaId + ' a ' + fechaFinalizacionPrevista);
        var data = {fecha_finalizacion_prevista: moment(fechaFinalizacionPrevista, DATEFROMAT_WEB).format(DATEFROMAT_SERVIDOR)};
        var promesa = Tarea.update({tareaId: tareaId}, data).$promise;
        promesa.then(function (data) {
            $log.debug(TAG + 'Fecha prevista editada correctamente!');
            var texto = Lang.get('seccion_tareas.mensaje_edit_fecha_ok');
            Sigo.UI.Toast.success('', texto);
        }, function (err) {
            $log.error(TAG + 'Error editando la fecha prevista!');
            Sigo.UI.Messages.open([Lang.get('seccion_tareas.mensaje_edit_fecha_error')], 0);
        });
        return promesa;
    }

    function editarFechaFinalizacion(tareaId, fechaFinalizacion) {
        $log.debug(TAG + 'Editando fecha finalización de la tarea ' + tareaId + ' a ' + fechaFinalizacion);
        var data = {fecha_finalizacion: moment(fechaFinalizacion, DATEFROMAT_WEB).format(DATEFROMAT_SERVIDOR)};
        var promesa = Tarea.update({tareaId: tareaId}, data).$promise;
        promesa.then(function (data) {
            $log.debug(TAG + 'Fecha finalización editada correctamente!');
            var texto = Lang.get('seccion_tareas.mensaje_edit_fecha_ok');
            Sigo.UI.Toast.success('', texto);
        }, function (err) {
            $log.error(TAG + 'Error editando la fecha finalización!');
            Sigo.UI.Messages.open([Lang.get('seccion_tareas.mensaje_edit_fecha_error')], 0);
        });
        return promesa;
    }

    function _editarFechaPrevista(tareaId, fechaActual) {
        $log.debug(TAG + 'Abriendo modal para editar la fecha prevista de la tarea ' + tareaId + '...');
        var fechaPrevista = fechaActual == "null" ? moment() : moment(fechaActual, DATEFROMAT_SERVIDOR);
        var data = {tareaId: tareaId, fechaPrevista: fechaPrevista.format(DATEFROMAT_WEB)};
        var opciones = {
            id: 'previ',
            titulo: ucfirst(Lang.get('nombres.editar')) + " " + Lang.choice('seccion_tareas.columna_fecha_finalizacion_prevista', 1),
            label: ucfirst(Lang.choice('seccion_tareas.columna_fecha_finalizacion_prevista', 1)),
            modelo: data.fechaPrevista,
            callbackSubmit: function (item) {
                return editarFechaFinalizacionPrevista(tareaId, item);
            }
        };

        return DialogsService.date(opciones);
    }

    function _editarFechaIniPrevista(tareaId) {
        return new Promise((resolve) => {
            $log.debug(TAG + 'Abriendo modal para editar la fecha inicio prevista de la tarea ' + tareaId + '...');

            const titulo = ucfirst(Lang.get('nombres.editar')) + " "
                + Lang.choice('seccion_tareas.columna_fecha_inicio_prevista', 1);

            const extraOptions = {
                botonOk: ucfirst(Lang.get('nombres.aceptar'))
            };

            const dialogo = __abrirDialogo(titulo, {id: tareaId}, extraOptions, DIALOG_FECHA_INI_PREVISTA_ID,
                DIALOG_FECHA_INI_PREVISTA_DIALOG_TEMPLATE);

            dialogo.then(function (result) {
                const datos = {fechaInicioPrevista:  moment(result.fecha, "DD/MM/YYYY HH:mm")
                        .format("YYYY-MM-DD HH:mm:ss")};
                if (result.minutos > 0) datos.minutos = result.minutos;

                $http.post(Sigo.var.path + '/api/v2/tareas/' + tareaId + '/editar-planificacion', datos)
                    .success(() => {
                        Sigo.UI.Toast.success('', Lang.get('mensajes.guardado_exito'));
                        resolve();
                    })
                    .error((data) => {
                        Sigo.UI.Toast.error('', data.message);
                    });
            });
        });
    }

    function _editarFechaFinalizacion(tareaId, fechaActual) {
        $log.debug(TAG + 'Abriendo modal para editar la fecha finalización de la tarea ' + tareaId + '...');
        var fechaPrevista = fechaActual == "null" ? moment() : moment(fechaActual, DATEFROMAT_SERVIDOR);
        var data = {tareaId: tareaId, fechaPrevista: fechaPrevista.format(DATEFROMAT_WEB)};
        var opciones = {
            id: 'fini',
            titulo: ucfirst(Lang.get('nombres.editar')) + " " + Lang.choice('seccion_tareas.columna_fecha_finalizacion', 1),
            label: ucfirst(Lang.choice('seccion_tareas.columna_fecha_finalizacion', 1)),
            modelo: data.fechaPrevista,
            callbackSubmit: function (item) {
                return editarFechaFinalizacion(tareaId, item);
            }
        };
        return DialogsService.date(opciones);
    }
}